
import React from "react";
import UsePanel from "./UserPanel";
import Contracts from '../Contract/Contracts';
import { Row, Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Dashboard = () => {
  document.title = "Dashboard | ONFON GROUP LEGAL - React Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Onfon" breadcrumbItem="Dashboard" />
          {/* User Panel Charts */}
          <UsePanel />       

          <Row>
            <Contracts isHome={true} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
